/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchAssetsLocationDetailsService } from '../../services/wellLocations/WellLocationsService';
// import { WellSearchObjectModel } from '../../models/WellSearchModel';

interface AssetLocationState {
    wellLocations: WellLocation[] | null;
    loading: boolean;
    error: string | null;
}

export interface WellLocation {
    lng: number;
    lat: number;
    assetGuid: string,
    assetName: string
    communicationStatus: string,
    customerName: string,
    lastGoodScanTime: string,
    latitude: number,
    longitude: number,
    runStatus: string,
    industryApplicationId?: number;
}
const initialState: AssetLocationState = {
    wellLocations: null,
    loading: false,
    error: null,
};

export const fetchAssetsLocationDetails: any = createAsyncThunk('AssetLocationsSlice/fetchAssetsLocationDetails', async (
) => {
    const response = await fetchAssetsLocationDetailsService();
    return response;
});

const AssetLocationsSlice = createSlice({
    name: 'AssetLocationsSlice',
    initialState,
    reducers: {
        resetAssetLocationsState: (state) => {
            state.wellLocations = null;
            state.error = null;
            state.loading = false;

        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAssetsLocationDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAssetsLocationDetails.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload?.values;
                state.wellLocations = data;
            })
            .addCase(fetchAssetsLocationDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message ?? 'Failed to fetch well locations';
            });
    },
});

export const { resetAssetLocationsState } = AssetLocationsSlice.actions;
export default AssetLocationsSlice.reducer;
